var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snowflake-header"},[_c('div',{staticClass:"menu"},[_c('router-link',{attrs:{"to":{ name: 'logout' }}},[_c('el-button',{attrs:{"type":"text"}},[_vm._v(_vm._s('Logout'))])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }